<template>
  <div class="app">
    <!-- 设置路由出口 -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {

}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

html,
body,
.app {
  width: 100%;
  height: 100%;
}
</style>
